import api from './axios';

export function getProfile(userId) {
  return api.get(`/profile/${userId}`).then(res => res.data);
}

export function updateProfile(userId, data) {
  return api.put(`/profile/${userId}`, data).then(res => res.data);
}

export function uploadAvatar(userId, file) {
  const formData = new FormData();
  formData.append('file', file);
  return api
    .post(`/profile/${userId}/avatar`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(res => res.data);
}

export function deleteAvatar(userId) {
  return api.delete(`/profile/${userId}/avatar`).then(res => res.data);
}
